import {
  ICommonListItemsResponse,
  IReportFiltersItems,
} from '../../shared/interfaces/static.interface'

export const COMMON_FETCH_SIGNATORY = '[COMMON] FETCH_SIGNATORY'
export const COMMON_FETCH_SIGNATORY_SUCCESS = '[COMMON] FETCH_SIGNATORY_SUCCESS'
export const COMMON_FETCH_SIGNATORY_ERROR = '[COMMON] FETCH_SIGNATORY_ERROR'

export const COMMON_FETCH_REPORT_FILTERS = '[COMMON] FETCH_REPORT_FILTERS'
export const COMMON_FETCH_REPORT_FILTERS_SUCCESS = '[COMMON] FETCH_REPORT_FILTERS_SUCCESS'
export const COMMON_FETCH_REPORT_FILTERS_ERROR = '[COMMON] FETCH_REPORT_FILTERS_ERROR'

export const COMMON_FETCH_AFFILIATES = '[COMMON] FETCH_AFFILIATES'
export const COMMON_FETCH_AFFILIATES_SUCCESS = '[COMMON] FETCH_FETCH_AFFILIATES_SUCCESS'
export const COMMON_FETCH_AFFILIATES_ERROR = '[COMMON] FETCH_FETCH_AFFILIATES_ERROR'

export const COMMON_FETCH_BASE_OF_ASSIGNMENTS = '[COMMON] FETCH_BASE_OF_ASSIGNMENTS'
export const COMMON_FETCH_BASE_OF_ASSIGNMENTS_SUCCESS = '[COMMON] FETCH_BASE_OF_ASSIGNMENTS_SUCCESS'
export const COMMON_FETCH_BASE_OF_ASSIGNMENTS_ERROR = '[COMMON] FETCH_BASE_OF_ASSIGNMENTS_ERROR'

export const CommonFetchSignatories = (data: any) => ({
  type: COMMON_FETCH_SIGNATORY,
  payload: data,
})

export const CommonFetchSignatoriesSuccess = (data: any) => ({
  type: COMMON_FETCH_SIGNATORY_SUCCESS,
  payload: data,
})

export const CommonFetchSignatoriesError = () => ({
  type: COMMON_FETCH_SIGNATORY_ERROR,
})

export const CommonFetchReportFilters = () => ({
  type: COMMON_FETCH_REPORT_FILTERS,
})

export const CommonFetchReportFiltersSuccess = (data: IReportFiltersItems) => ({
  type: COMMON_FETCH_REPORT_FILTERS_SUCCESS,
  payload: data,
})

export const CommonFetchReportFiltersError = () => ({
  type: COMMON_FETCH_REPORT_FILTERS_ERROR,
})

export const CommonFetchAffiliates = () => ({
  type: COMMON_FETCH_AFFILIATES,
})

export const CommonFetchAffiliatesSuccess = (data: ICommonListItemsResponse) => ({
  type: COMMON_FETCH_AFFILIATES_SUCCESS,
  payload: data,
})

export const CommonFetchAffiliatesError = () => ({
  type: COMMON_FETCH_AFFILIATES_ERROR,
})

export const CommonFetchBaseOfAssignments = () => ({
  type: COMMON_FETCH_BASE_OF_ASSIGNMENTS,
})

export const CommonFetchBaseOfAssignmentsSuccess = (data: ICommonListItemsResponse) => ({
  type: COMMON_FETCH_BASE_OF_ASSIGNMENTS_SUCCESS,
  payload: data,
})

export const CommonFetchBaseOfAssignmentsError = () => ({
  type: COMMON_FETCH_BASE_OF_ASSIGNMENTS_ERROR,
})
